import type { Links } from '@which/seatbelt'
import { MultiLinkBlock } from '@which/seatbelt'
import { dynamicGa4DataLayerPush } from '@which/shared'

import type { RecommendedContentType } from '../../../models'
import styles from './RecommendationsTextLinksLayout.module.scss'

const getLinks = ({
  recommendations,
  sectionTitle,
  whichId,
  position,
}: {
  recommendations: RecommendedContentType[]
  sectionTitle: string
  whichId: string
  position?: string
}) => {
  const links = recommendations.map((recommendation, index): Links[number] => {
    const title = recommendation.__typename == 'RecommendedArticle' ? recommendation.title : ''
    const analyticsInfo = position && `r4u-${position}-link-${index + 1}`

    const link: Links[number] = {
      type: 'standard',
      href: recommendation.href,
      text: title,
      clickHandler: () => {
        dynamicGa4DataLayerPush({
          event: 'notification_ab_test',
          item_text: analyticsInfo ?? title,
          item_parent_text: sectionTitle,
          item_group: whichId,
        })
      },
    }

    return link
  })

  return links
}

type RecommendationsTextLinksLayoutProps = {
  recommendations: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
  position?: string
}

export const RecommendationsTextLinksLayout = ({
  recommendations,
  title,
  whichId,
  modelId,
  position,
}: RecommendationsTextLinksLayoutProps) => (
  <MultiLinkBlock
    componentType={'r4u'}
    title={title}
    links={getLinks({ recommendations, sectionTitle: title, whichId, position })}
    className={styles.recommendationTextLinks}
    data-which-id={whichId}
    data-parent-text={modelId}
  />
)
